import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-products-interested',
  templateUrl: './products-interested.component.html',
  styleUrls: ['./products-interested.component.scss']
})
export class ProductsInterestedComponent implements OnInit {
  productList: any[]=[];
  userId: number = 0;
  loader: boolean = false;

  constructor(
    private adminservice: AdminService,
    private dialogRef: MatDialogRef<ProductsInterestedComponent>,
    private activeroute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any[],
  ) { }

  ngOnInit() {
    this.getProducts();
    this.activeroute.queryParams.subscribe(params => {
      this.userId = +params['userId'];
    });
  }

  getProducts(){
    this.adminservice.getProducts().subscribe(
      (response)=>{
        if (response.rtn) {
          this.productList = response.result;
          this.productList.forEach((element)=> element.checked = false );

          if (this.data.length > 0) {
            this.productList.forEach((element)=>{
              let find = this.data.find((item)=>item.producto_id == element.id)
              if (find) {
                element.checked = true;
              }
            })
          }
        }
      }
    );
  }

  asignProducts(){
    const request = {
      cliente_id: this.userId,
      productos: this.productList.filter((element)=>element.checked).map((element)=>(+element.id))
    }
    this.loader = true;
    this.adminservice.asignProducts(request).subscribe(
      (response)=>{
        this.loader = false;
        if (response.rtn) {
          this.dialogRef.close(true);
        }
      }
    );
  }

}
